<template>
    <div>
        <div class="profile-style rw-people">
            <h5 class="mb-4">Basic Information</h5>
            <b-card class="bdr-15 card-style">
                <ValidationObserver ref="form">

                    <div class="form-group">
                        <label>Domain Name</label>
                        <input disabled v-model="website.domain" type="text" class="form-control" name="categories">
                    </div>

                    <validation-provider v-if="!website.logo" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                        <div class="form-group mt-3">
                            <div class="mb-1">
                                <label>Logo Website</label>
                            </div>
                            <div class="btn-up d-flex align-items-center" @click="clickUploadImage('logo')">
                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                            </div>
                            <input ref="logo" 
                                    type="file"
                                    class="custom-file-input d-none"
                                    id="Thumbnail"
                                    v-on:change="onImageUpload($event,'logo')"
                                    accept="image/jpeg,image/png,image/jpg" 
                                    @input="validate" >
        
                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                        </div>
                    </validation-provider>
                    
                    <div class="form-group mt-3" v-if="website.logo">   
                        <div class="mb-1">
                            <label>Logo Website</label>
                        </div> 
                        <button v-on:click.prevent="removeImageUpload('logo')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                        <div class="input-group img-sh">
                            <img :src="website.logo" class="logo-img img-responsive">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Address</label>
                                <input v-model="website.address" type="text" class="form-control" name="categories">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <validation-provider rules="email" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Email</label>
                                    <input v-model="website.email" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>
                        <div class="col-md-6">
                            <validation-provider rules="numeric" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <input v-model="website.phone" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>
                        <div class="col-md-6">  
                            <validation-provider rules="required|numeric" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Whatsapp</label>
                                    <input v-model="website.whatsapp" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>
                        <div class="col-md-12">  
                            <validation-provider rules="multi_url" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Social Media</label>
                                    <textarea v-model="website.sosmed" class="form-control"></textarea>
                                    <small>Separate urls with commas(,) if you want to load more than one link</small>
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>
                        <div class="col-md-12">  
                            <div class="form-group">
                                <label>Google Tag Manager ID</label>
                                <input v-model="website.gtag" type="text" class="form-control" name="categories">
                                <small>Put your google tag manager id for load your google analytics or google ads</small>
                            </div>
                        </div>
                        <div class="col-md-12">  
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Copyright</label>
                                    <input v-model="website.copyright" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                        </div>
                    </div>

                    <div class="text-right mt-3">
                        <button v-on:click="validationForm('basic')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                            Save Event
                        </button>
                    </div>

                </ValidationObserver>
            </b-card>
        </div>

        <div class="profile-style">
            <h5 class="mb-4">Color Settings</h5>
            <b-card class="bdr-15 card-style position-relative">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Main Backgound Color</label>
                            <div class="input-group inp-c">
                                <input type="color" :style="{backgroundColor:website.main_bg}" v-model="website.main_bg" class="form-control color" name="categories">
                                <div v-if="website.main_bg" class="input-group-append ga-color" @click="website.main_bg = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group inp-c">
                            <label>Second Backgound Color</label>
                            <div class="input-group">
                                <input type="color" :style="{backgroundColor:website.second_bg}" v-model="website.second_bg" class="form-control color" name="categories">
                                <div v-if="website.second_bg" class="input-group-append ga-color" @click="website.second_bg = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group inp-c">
                            <label>Main Text Color</label>
                            <div class="input-group">
                                <input type="color" :style="{backgroundColor:website.main_color}" v-model="website.main_color" class="form-control color" name="categories">
                                <div v-if="website.main_color" class="input-group-append ga-color" @click="website.main_color = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group inp-c">
                            <label>Second Text Color</label>
                            <div class="input-group">
                                <input type="color" :style="{backgroundColor:website.second_color}" v-model="website.second_color" class="form-control color" name="categories">
                                <div v-if="website.second_color" class="input-group-append ga-color" @click="website.second_color = null">
                                    <div class="input-group-text">
                                        <i class="uil uil-multiply"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-right mt-3">
                    <button v-on:click="validationForm('color')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Event
                    </button>
                </div>

            </b-card>
        </div>

        <div class="profile-style rw-people">
            <h5 class="mb-4">Meta Information</h5>
            <b-card class="bdr-15 card-style">
                <ValidationObserver ref="form">

                        <validation-provider v-if="!website.meta_image" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                            <div class="form-group mt-3">
                                <div class="mb-1">
                                    <label>Cover Image</label>
                                </div>
                                <div class="btn-up d-flex align-items-center" @click="clickUploadImage('meta_image')">
                                    <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                </div>
                                <input ref="meta_image" 
                                        type="file"
                                        class="custom-file-input d-none"
                                        id="Thumbnail"
                                        v-on:change="onImageUpload($event,'meta_image')"
                                        accept="image/jpeg,image/png,image/jpg" 
                                        @input="validate" >
            
                                <div class="invalid-input mt-3">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                        
                        <div class="form-group mt-3" v-if="website.meta_image">   
                            <div class="mb-1">
                                <label>Cover Image</label>
                            </div> 
                            <button v-on:click.prevent="removeImageUpload('meta_image')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                            <div class="input-group img-sh">
                                <img :src="website.meta_image" class="logo-img img-responsive">
                            </div>
                        </div>

                    <div class="form-group">
                        <label>Meta Title</label>
                        <input v-model="website.meta_title" type="text" class="form-control" name="categories">
                    </div>

                    <div class="form-group">
                        <label>Meta Description</label>
                        <textarea v-model="website.meta_desc" class="form-control"></textarea>
                    </div>

                    <div class="text-right mt-3">
                        <button v-on:click="validationForm('meta')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                            Save Event
                        </button>
                    </div>

                </ValidationObserver>
            </b-card>
        </div>

    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";

    export default{
        data(){
            return{
                loading:false,
                meta_image:'',
                logo:''
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        computed: {
            ...mapState('WebsiteControl', {
                website: state => state.website,
            }),
            
           
        },
        methods:{
            ...mapActions('WebsiteControl', ['getWebsite','updateSettings']),
            
            clickUploadImage:function(type){
                // console.log(this.$refs[type])
                this.$refs[type].click()
            },
            onImageUpload: function(event,type) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.website[type] = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this[type] = input.files[0]
            },
            removeImageUpload:function(type){
                 this[type] = ''
                 this.website[type] = ''
            },

            validationForm: function(type) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                       
                        if(type == 'meta'){
                            formData.append('meta_title', this.website.meta_title ? this.website.meta_title : '');
                            formData.append('meta_desc', this.website.meta_desc ? this.website.meta_desc : '');
                            formData.append('meta_image_file', this.meta_image);
                            formData.append('meta_image', this.website.meta_image ? this.website.meta_image : '');
                        }
                        else if(type == 'color'){
                            formData.append('main_color', this.website.main_color ? this.website.main_color : '');
                            formData.append('second_color', this.website.second_color ? this.website.second_color : '');
                            formData.append('main_bg', this.website.main_bg ? this.website.main_bg : '');
                            formData.append('second_bg', this.website.second_bg ? this.website.second_bg : '');
                        }
                        else if(type == 'basic'){
                            formData.append('logo_file', this.logo);
                            formData.append('logo', this.website.logo ? this.website.logo : '');
                            formData.append('gtag', this.website.gtag ? this.website.gtag : '');
                            formData.append('email', this.website.email ? this.website.email : '');
                            formData.append('phone', this.website.phone ? this.website.phone : '');
                            formData.append('address', this.website.address ? this.website.address : '');
                            formData.append('whatsapp', this.website.whatsapp ? this.website.whatsapp : '');
                            formData.append('copyright', this.website.copyright ? this.website.copyright : '');
                            formData.append('sosmed', this.website.sosmed ? this.website.sosmed : '');
                            formData.append('is_domain_tema', this.website.is_domain_tema);
                        }

                        formData.append("type", type);
                        formData.append("_method", "put");

                        this.updateSettings(formData).then(() => {
                            this.loading = false
                            this.meta_image = ''
                            this.getWebsite(this.$route.params.id)
                            this.$toast.success('Successfully Update Settings')
                        }).catch((error) => {
                            console.log(error)
                            this.loading = false
                            this.$toast.warning('Sorry, Something Error')
                        })

                    }
                });
            },
        }
    }

</script>

<style scoped>
    .btn-image-remove{
        padding: 0px 15px;
    }
    .logo-img{
        width: 140px;
        height: auto;
    }
    .inp-c .color{
        border: 1px solid #dddddd;
        border-radius: 0px;
    }
    .inp-c .input-group-text{
        height: 42px;
        margin-top: 0px;
    }
</style>